<p-table [value]="categories" dataKey="id" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template #header>
    <tr>
      <th i18n>Category</th>
      <th i18n>Recipe</th>
    </tr>
  </ng-template>
  <ng-template #body let-kat>
    <tr>
      <td>{{ kat.kategori }}</td>
      <td>
        <p-table
          [value]="data.filter((x) => x.category?.id == kat.id)"
          dataKey="id"
          [tableStyle]="{ 'min-width': '50rem' }"
        >
          <ng-template #body let-row>
            <tr>
              <td>
                <a [routerLink]="['resibe', row.id]">{{ row.name }}</a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </td>
    </tr>
  </ng-template>
</p-table>
